export default class JoyrideSelectors {
    static shouldStartJoyride = (state) => state.joyride.runJoyride;

    static getJoyrideStatus = (state) => state.joyride.joyrideStatus;

    static getJoyrideStatusSaveInProgress = (state) =>
        state.joyride.joyrideStatusSaveInProgress;
}



// WEBPACK FOOTER //
// ./app/selectors/joyride.js